import moment from 'moment'

export function isArrayItemUnique(arr, field = null) {
  if (arr?.length) {
    let set
    if (!field) {
      set = new Set(arr)
    } else {
      set = new Set(arr.map(item => item[field]))
    }
    if (set.size !== arr.length) return false
  }
  return true
}

/**
 *
 * @param {Array} dateRanges
 * @param {string} dateRanges[].startDate - eg: '2023-01-01'
 * @param {string} dateRanges[].endDate - endDate always >= startDate
 *
 * @returns {boolean}
 */
export function isDateRangesUnique(dateRanges) {
  dateRanges = dateRanges.map(range => ({
    startDate: new Date(range.startDate).getTime(),
    endDate: new Date(range.endDate).getTime()
  }))

  // Sort dateRanges by startDate
  dateRanges.sort((a, b) => a.startDate - b.startDate)

  for (let i = 0; i < dateRanges.length - 1; i++) {
    const currentRange = dateRanges[i]
    const nextRange = dateRanges[i + 1]

    if (currentRange.endDate >= nextRange.startDate) {
      return false
    }
  }
  return true
}

// handle currency
export function format1(n, currency) {
  return (
    currency +
    n?.toFixed(2).replace(/./g, function (c, i, a) {
      return i > 0 && c !== '.' && (a.length - i) % 3 === 0 ? ',' + c : c
    })
  )
}
// vnd
export function formatVND(n, currency) {
  // return (
  //   (currency || '') +
  //   (n?.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') || '')
  // )
  return (
    (currency || '') +
    (n
      ?.toFixed(2)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      .slice(0, -3) || '')
  )
}
export function throttle(fn, wait = 200) {
  let throttled = false
  return function (...args) {
    if (!throttled) {
      fn.apply(this, args)
      throttled = true
      setTimeout(() => {
        throttled = false
      }, wait)
    }
  }
}

const devForm = 'YYYY-MM-DD HH:mm:ss'
const userForm = 'DD-MM-YYYY HH:mm:ss'
export function datetimeDevToUser(devString) {
  return moment(devString, devForm).format(userForm)
}
export function datetimeUserToDev(userString) {
  return moment(userString, userForm).format(devForm)
}
